// extracted by mini-css-extract-plugin
export default {"wrapper":"_599d8ca2","imageLink":"_3c2edc76","image":"_d153b396","placeholder":"_beada8d2","name":"_6266bd36","nameLink":"_be2c7856"};